export { default } from './ControlsSection';
